import tippy from 'tippy.js';
import './index.sass';
import 'tippy.js/dist/tippy.css';

export default () => {
  const showDetails = $('.js-show-details');

  if(showDetails.length) {
    showDetails.on('click', function() {
      $(this).toggleClass('profile-info__dots--show');
      $('.profile__details').slideToggle();
    })
  }

  const $isReadyForWorkBadge = $('.profile-info__ready')
  $isReadyForWorkBadge && tippy('.profile-info__ready', {
    placement: 'bottom',
    content: 'Свободен для работы'
  });
}
